import {
  UploadedDocument,
  DocumentTypesOrderMap,
  MultiOptionButtonOption,
} from '@urbanx/agx-ui-components';
import { DocumentTypes } from '@urbanx/agx.campaigns.client';

const maxDocumentTypeOrder = 999;

export const sortDocumentsByType = (documents: UploadedDocument[] = []) => {
  return [...(documents ?? [])].sort((a, b) => {
    const aOrder = getDocumentOrderFromFileType(a.documentType);
    const bOrder = getDocumentOrderFromFileType(b.documentType);

    return aOrder - bOrder;
  });
};

export const sortDocumentsByTypes = (
  documents: UploadedDocument[] = [],
  sortByDocumentTypes: DocumentTypes[]
) => {
  return [...(documents ?? [])].sort((a, b) => {
    const aIndex = sortByDocumentTypes.indexOf(a.documentType);
    const bIndex = sortByDocumentTypes.indexOf(b.documentType);

    const aPriority = aIndex !== -1 ? aIndex : maxDocumentTypeOrder;
    const bPriority = bIndex !== -1 ? bIndex : maxDocumentTypeOrder;

    return aPriority - bPriority;
  });
};

export const sortMultiOptionButtonOptionsByType = (
  buttonOptions: MultiOptionButtonOption[] = []
) => {
  return [...(buttonOptions ?? [])].sort((a, b) => {
    const aOrder = getDocumentOrderFromFileType(a.documentType);
    const bOrder = getDocumentOrderFromFileType(b.documentType);

    return aOrder - bOrder;
  });
};

const getDocumentOrderFromFileType = (fileType?: DocumentTypes): number => {
  if (fileType === undefined) return maxDocumentTypeOrder;

  const documentTypeOrderKey = Object.keys(DocumentTypesOrderMap).find((key) => key === fileType);

  if (documentTypeOrderKey == undefined) return maxDocumentTypeOrder;

  const documentTypeOrderValue =
    DocumentTypesOrderMap[documentTypeOrderKey as keyof typeof DocumentTypesOrderMap];

  if (documentTypeOrderValue == undefined) return maxDocumentTypeOrder;

  return documentTypeOrderValue;
};
